import { DEFAULT_LOCALE } from 'src/constants';

let cache: Translations = {} as Translations;

function fetch() {
  return cache;
}

function clear() {
  const defaultMessages = cache[DEFAULT_LOCALE];
  cache = {} as Translations;

  if (defaultMessages) {
    store({ [DEFAULT_LOCALE]: defaultMessages } as Translations);
  }
}

async function store(value: Translations) {
  cache = { ...cache, ...value };
}

const util = {
  fetch,
  clear,
  store,
};

export { util as cache };
